import { useState } from 'react';
import { Link } from 'react-router-dom';

/**
 * Convert common share-link variants (Google Drive, Dropbox) to direct image URLs.
 */
function toDirectImageUrl(url) {
  if (!url || typeof url !== 'string') return url;
  // Google Drive: https://drive.google.com/file/d/<ID>/view?usp=...
  const driveMatch = url.match(/drive\.google\.com\/file\/d\/([^/]+)\//);
  if (driveMatch) {
    return `https://drive.google.com/uc?export=view&id=${driveMatch[1]}`;
  }
  // Google Drive open?id=
  const driveOpen = url.match(/drive\.google\.com\/open\?id=([^&]+)/);
  if (driveOpen) {
    return `https://drive.google.com/uc?export=view&id=${driveOpen[1]}`;
  }
  // Dropbox: ?dl=0 -> ?raw=1
  if (url.includes('dropbox.com') && url.includes('dl=0')) {
    return url.replace('dl=0', 'raw=1');
  }
  return url;
}

/**
 * Reusable public-page brand logo.
 * Renders settings.logo_url (image) if it loads successfully,
 * otherwise falls back to logo_text in the Playball brand font
 * with the trailing yellow dot — matching the customer booking page.
 */
export default function BrandLogo({ logoUrl, logoText, fallback = 'La Contadina', className = '', testId = 'brand-logo' }) {
  const [imgFailed, setImgFailed] = useState(false);
  const text = logoText || fallback;
  const src = logoUrl ? toDirectImageUrl(logoUrl) : null;
  const showImage = src && !imgFailed;

  return (
    <Link to="/" className={`inline-block ${className}`} data-testid={testId}>
      {showImage ? (
        <img
          src={src}
          alt={text}
          onError={() => setImgFailed(true)}
          className="h-12 md:h-16 w-auto object-contain"
          data-testid={`${testId}-img`}
        />
      ) : (
        <span className="font-brand text-4xl md:text-5xl text-[#1C1C19] tracking-tight" data-testid={`${testId}-text`}>
          {text}<span className="text-[#EAB308]">.</span>
        </span>
      )}
    </Link>
  );
}
